import { render, staticRenderFns } from "./ColorMonitors.vue?vue&type=template&id=777632b2&scoped=true&"
import script from "./ColorMonitors.vue?vue&type=script&lang=js&"
export * from "./ColorMonitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777632b2",
  null
  
)

export default component.exports